import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Input, Button, Radio} from "antd"
import {createBatchThankCard, exportItemJson} from "../../../../services/api/3dApi"

class CreateBatch extends Component {
    state = {
        error: "",
        loading: false,
        inputName: '',
        level: "1",
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.barcodes.length !== this.props.barcodes.length) {
            this._handleRefresh()
        }
    }

    _handleRefresh = () => {
        this.setState({
            error: "",
            loading: false,
            inputName: '',
            level: "1",
        })
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _handleSubmitBatch = async () => {
        const {barcodes, onClear} = this.props
        const {inputName, level} = this.state

        this.setState({
            error: '',
            loading: true
        })

        try {
            const payload = {
                templates: barcodes,
                user_create: inputName,
                level: level
            }

            const {data: response} = await createBatchThankCard(payload)

            const {success, error, data} = response

            if (!success) {
                return this.setState({
                    error,
                    loading: false
                })
            }

            //const {errorResult} = data
            const {_id} = data.batch

            // if (errorResult.length > 0) {
            //     notification.error({
            //         message: 'ERROR',
            //         description: <ErrorList list={errorResult}/>,
            //         duration: 0,
            //     })
            // }

            if (_id) {
                await onClear()
                await this._handleDownloadJson(_id)
                await window.open(`/batches/${_id}`, "_blank");
            }

            this.setState({
                loading: false
            })
        } catch (error) {
            this.setState({
                loading: false,
                error: error.message
            })
        }
    }

    _handleDownloadJson = async (batchID) => {
        window.open(exportItemJson(batchID))
    }

    render() {
        const {inputName, level, loading, error} = this.state

        return (
            <div className="CreateBatch d-flex align-items-center justify-content-between mb-4">
                <div className="d-flex">
                    <div className="InputName ItemInput d-flex align-items-center mr-5">
                        <label className="mb-0 mr-3 font-weight-bold">Người tạo: </label>
                        <Input name="inputName" value={inputName} onChange={this._handleChangeInput}/>
                    </div>
                    <div className="Level ItemInput d-flex align-items-center">
                        <label className="mb-0 mr-3 font-weight-bold">Độ ưu tiên: </label>
                        <Radio.Group name="level" value={level} onChange={this._handleChangeInput}>
                            <Radio value="1">Medium</Radio>
                            <Radio value="2">High</Radio>
                            <Radio value="3">Highest</Radio>
                        </Radio.Group>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    {error && <div className="mr-3 text-danger">{error}</div>}
                    <Button onClick={this._handleSubmitBatch} loading={loading} type="primary">Tải file & Tạo
                        lô</Button>
                </div>
            </div>
        )
    }
}

CreateBatch.propTypes = {
    barcodes: PropTypes.array,
    onClear: PropTypes.func.isRequired
}

export default CreateBatch
